module.exports = require('./dist').default



//////////////////
// WEBPACK FOOTER
// ./~/chinese-to-pinyin/index.js
// module id = 517
// module chunks = 158